import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { useEffect, useState } from 'react';
import { getAllChildrenQuestions, getChildrenOfAParentQuestion } from '../components/utils/questionUtils';
/*
    1. Set Form values on change
    2. Find child questions for the given parent question
    3. Update 'occurance' key for child quesitions by 1. This is done to keep a track if a question occurs as child for multiple parents.
    4. Add child questions to a map of {<parentKey> : [<childkey1>, <childkey2>]} so that next time if the
      value for same parent changes, we can refer to this state and hide these quesitons without having to run a
      loop again to find the child questions.
  */

export const useRenderDependentQuestion = appTrustData => {
  const {
    enableForgeRemoteDataResidencyChanges
  } = useStatsig();
  const allChildQuestions = getAllChildrenQuestions(enableForgeRemoteDataResidencyChanges());
  const [childQuestionsVisible, setChildQuestionsVisible] = useState({});
  const [hiddenQuestions, setHiddenQuestions] = useState({});

  // Initially set all child que as hidden
  useEffect(() => {
    if (!appTrustData) {
      setHiddenQuestions(_objectSpread({}, allChildQuestions));
    }
  }, []);

  // Trigger this function when a parent que on change is called, here it is presumed that only que with radio type are parent.
  const parentQueOnChange = (questionKey, value, formData) => {
    const childQuestions = getChildrenOfAParentQuestion(questionKey, value, enableForgeRemoteDataResidencyChanges());
    let newHiddenQuestions;
    if (!Object.keys(hiddenQuestions).length) {
      newHiddenQuestions = _objectSpread({}, allChildQuestions);
    } else {
      newHiddenQuestions = _objectSpread({}, hiddenQuestions);
    }
    if (childQuestions !== null && childQuestions !== void 0 && childQuestions.length) {
      var _childQuestionsVisibl;
      // This handling is required for the questions where two options of same question have different dependencies defined
      // i.e A.a -> B & C , A.b -> B. In this case, we check if the question already has any dependecy defined.
      // If yes, reduce the occurance for its dependent question and remove it from the object childQuestionsVisible
      if ((_childQuestionsVisibl = childQuestionsVisible[questionKey]) !== null && _childQuestionsVisibl !== void 0 && _childQuestionsVisibl.length) {
        childQuestionsVisible[questionKey].forEach(que => {
          if (newHiddenQuestions[que].occurance) {
            newHiddenQuestions[que].occurance -= 1;
            if (!newHiddenQuestions[que].occurance) delete formData[que];
          }
        });
        delete childQuestionsVisible[questionKey];
      }
      childQuestionsVisible[questionKey] = childQuestions.map(child => child.key); // {<parentKey> : [<childkey1>, <childkey2>]}
      setChildQuestionsVisible(childQuestionsVisible);

      // This is done to track if a question appears as child for more than 1 parents.
      // i.e if A -> & B -> C, then occurance of C = 2. If A's response is changed, we decrement C by 1. It should not be removed in this case since B -> C
      childQuestionsVisible[questionKey].forEach(que => {
        newHiddenQuestions[que].occurance += 1;
      });
    } else {
      // Here we recursively find out the que to be removed.
      // This is done to identify the nested children which should be removed it top most que in hierarchy is removed
      // i.e if A -> B,C and B -> D and D -> E, then removing A should remove B, D & E.
      const getChildQueToBeRemoved = (obj, key, result) => {
        if (obj[key]) {
          result.push(key);
          const ele = [...obj[key]];
          delete obj[key];
          ele.forEach(el => {
            if (obj[el] && newHiddenQuestions[el].occurance < 2) {
              getChildQueToBeRemoved(obj, el, result);
            }
          });
        }
        return result;
      };
      const childQuestionsToBeRemoved = getChildQueToBeRemoved(_objectSpread({}, childQuestionsVisible), questionKey, []);
      // This iteration is done to add all the nested child questions to hidden que list
      childQuestionsToBeRemoved.forEach(val => {
        var _childQuestionsVisibl2;
        (_childQuestionsVisibl2 = childQuestionsVisible[val]) === null || _childQuestionsVisibl2 === void 0 ? void 0 : _childQuestionsVisibl2.forEach(que => {
          if (newHiddenQuestions[que].occurance) {
            newHiddenQuestions[que].occurance -= 1;
            if (!newHiddenQuestions[que].occurance) delete formData[que];
          }
        });
      });
      const newChildQueVisible = _objectSpread({}, childQuestionsVisible);
      delete newChildQueVisible[questionKey];
      setChildQuestionsVisible(newChildQueVisible);
    }
    setHiddenQuestions(newHiddenQuestions);
  };
  return {
    hiddenQuestions,
    parentQueOnChange
  };
};